module.exports = __webpack_public_path__ + "amazing-team.jld6dCha.svg";